let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f8DUi")).then(() => parcelRequire('dm0fl'));